// import React from "react";
// import { Link } from "react-router-dom";
// // import navigationContext from "../../contexts/navigationsContext";
// import { Dropdown, Space } from 'antd';
import { navigations } from "../../Data/navigation.js";

// const Navigation = () => (
//   <Space direction="horizontal">
//       {
//         navigations &&
//         navigations.length > 0 && (
//           navigations
//           .filter((item=>item.id ==1 || item.id ==2 ||item.id ==3 || item.id ==4 || item.id ==5))
//           .map((item) => (
//             <Space key={item.id} wrap>
//               {item.submenu ? 
//               <Dropdown
//                 className={item.title === "Home" ? "Home-item" : ""}
//                 menu={{
//                   items:item.submenu ? item.items.map((item) =>(
//                       {
//                         key: item.id,
//                         label: <Link to={item.link}>{item.title}</Link>,
//                         children: item.submenu ? item.items.map((nestedItem) => ({
//                           key: nestedItem.id,
//                           label: <Link to={nestedItem.link}>{nestedItem.title}</Link>,
//                         })) : undefined,
//                       }
//                     )):[],
//                   }}
//                   >
//                 <div>{item.title}<i className="fa fa-solid fa-caret-down"></i></div>
//               </Dropdown>
//                : <div><Link to={item.link}>{item.title}</Link></div>}
//             </Space>
//           ))
//         )
//       }
//   </Space>
// );
// export default Navigation;  

import { useState, useEffect } from "react";
import { Space, Dropdown } from "antd";
import { Link } from "react-router-dom";

const NavigationMenu = () => {
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      if (openDropdown !== null) setOpenDropdown(null);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [openDropdown]);

  return (
    <Space direction="horizontal">
      {navigations &&
        navigations.length > 0 &&
        navigations
          .filter((item) => [1, 2, 3, 4, 5].includes(item.id))
          .map((item) => (
            <Space key={item.id} wrap>
              {item.submenu ? (
                <Dropdown
                  className={item.title === "Home" ? "Home-item" : ""}
                  open={openDropdown === item.id} // Manage dropdown visibility
                  onOpenChange={(isOpen) => setOpenDropdown(isOpen ? item.id : null)}
                  menu={{
                    items: item.items.map((subItem) => ({
                      key: subItem.id,
                      label: <Link to={subItem.link}>{subItem.title}</Link>,
                      children: subItem.submenu
                        ? subItem.items.map((nestedItem) => ({
                            key: nestedItem.id,
                            label: <Link to={nestedItem.link}>{nestedItem.title}</Link>,
                          }))
                        : undefined,
                    })),
                  }}
                >
                  <div>
                    {item.title} <i className="fa fa-solid fa-caret-down"></i>
                  </div>
                </Dropdown>
              ) : (
                <div>
                  <Link to={item.link}>{item.title}</Link>
                </div>
              )}
            </Space>
          ))}
    </Space>
  );
};

export default NavigationMenu;
